// NavBar.jsx
import React, { useState,useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button, Dropdown, Avatar, Drawer } from 'antd';
import axios from "axios";
import {
  MenuOutlined,
  UserOutlined,
  DownOutlined,
  LogoutOutlined,
  DashboardOutlined,
  DollarOutlined,
  CalendarOutlined,
  FileProtectOutlined ,
  BookOutlined,
  VideoCameraOutlined,
  SolutionOutlined,
  TeamOutlined,
  FileDoneOutlined,
  HomeOutlined,
   MessageOutlined,
  ExperimentOutlined,
} from '@ant-design/icons';
import logo from '../utils/assets/login-illustration.png';
import io from "socket.io-client";


const socket = io(process.env.REACT_APP_API_SOCKET, {
  transports: ["websocket"],
  auth: {
    token: localStorage.getItem("token"),
  },
});

export default function NavBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

const [chatUnread, setChatUnread] = useState(
  Number(localStorage.getItem("chatUnreadCount")) || 0
);

  // Auth info
  const token = localStorage.getItem('token');
  const fullName = localStorage.getItem('fullName');
  const role = (localStorage.getItem('role') || '').toUpperCase();
  const avatarUrl = localStorage.getItem('profilePhotoUrl');
  const studentStatus = localStorage.getItem('studentStatus');;
  const isAuthenticated = Boolean(token);

  const isLoginPage = location.pathname === "/user/sign_in";
  const isVerifyOtp = location.pathname === "/user/verify-otp";

  const ROLE_HOME_ROUTES = {
  ADMIN: "/user/admin-home-page",
  INSTRUCTOR: "/user/instructor-home-page",
  OPERATIONS: "/user/operations-home-page",
  STUDENT: "/user/student-home-page",
};






  /* ===============================
     ROLE BASED NAVIGATION
  =============================== */

  const NAV_ITEMS_BY_ROLE = {
    ADMIN: [
      'Courses Management','Users','Chats','Dashboards','Tickets','Jobs','Resources Hub',
    ],
    OPERATIONS: [
      'Courses','Chats','Dashboards','Tickets','Jobs','Resources Hub',
    ],
    INSTRUCTOR: [
      'My Batches','Chats',
      'Mock Interviews','Jobs', 'Resources Hub',
    ],
    STUDENT: [
      'My Courses', 'Chats',
      'Jobs', 'All Active Mock Interviews', 'Resources Hub',
    ],
  };


  
  
  
  const navItems = ['Home', ...(NAV_ITEMS_BY_ROLE[role] || [])];

  const NAV_ICONS = {
    Home: <HomeOutlined />,
    Leads: <UserOutlined />,
    Demo: <VideoCameraOutlined />,
    Nurturing: <DashboardOutlined />,
    Enrollments: <FileDoneOutlined />,
    Users: <TeamOutlined />,
    Revenue: <DollarOutlined />,
    'My Batches': <BookOutlined />,
    Students: <TeamOutlined />,
    'Mock Interviews': <VideoCameraOutlined />,
    'All Active Mock Interviews': <VideoCameraOutlined/>,
    Attendance: <CalendarOutlined />,
    'Courses': <BookOutlined />,
    'My Courses': <BookOutlined />,
    'Courses Management': <BookOutlined />,
    'Live Classes': <VideoCameraOutlined />,
    'Payment Status': <DollarOutlined />,
    Chats: <MessageOutlined />,
  Dashboards: <DashboardOutlined />,
  Tickets: <FileProtectOutlined />,
  Jobs: <SolutionOutlined    />,
  "Resources Hub": <ExperimentOutlined />,
  };

  const slugify = (text) =>
    text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

 const handleNavClick = (key) => {
  if (key === 'Home') {
    const role = (localStorage.getItem("role") || "").toUpperCase();

    switch (role) {
      case "ADMIN":
        navigate("/user/admin-home-page");
        break;

      case "INSTRUCTOR":
        navigate("/user/instructor-home-page");
        break;

      case "OPERATIONS":
        navigate("/user/operations-home-page");
        break;

      case "STUDENT":
        navigate("/user/student-home-page");
        break;

      default:
        navigate("/user/sign_in");
    }

  } else {
  const role = (localStorage.getItem("role") || "").toUpperCase();

  const ROLE_BASE_PATHS = {
    ADMIN: "/academy/admin",
    STUDENT: "/academy/mentee-dashboard",
    INSTRUCTOR: "/academy/mentor-dashboard",
    OPERATIONS: "/academy/operations",
  };

  const basePath = ROLE_BASE_PATHS[role] || "/academy";

  navigate(`${basePath}/${slugify(key)}`);
}

  setDrawerOpen(false);
};


  const handleLogout = () => {
    localStorage.clear();
    navigate('/user/sign_in');
  };

  const getInitials = (name = '') =>
    name.split(' ').map(n => n[0] || '').slice(0, 2).join('').toUpperCase();

  /* ===============================
     DROPDOWN (AntD v5)
  =============================== */

  const getProfileRoute = () => {
  switch (role) {
    case "STUDENT":
      return "/user/mentee-dashboard/profile";

    case "INSTRUCTOR":
      return "/user/mentor-dashboard/profile";

    case "ADMIN":
      return "/user/admin/profile";

    case "OPERATIONS":
      return "/user/operations/profile";

    default:
      return "/profile"; // fallback
  }
};

  const userMenuItems = [
    {
      key: 'profile',
      label: 'Profile',
      onClick: () => navigate(getProfileRoute()),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />,
      danger: true,
      onClick: handleLogout,
    },
  ];

  const fetchUnreadCounts = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/chat/unread-counts`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.success) {
      const total = res.data.data.reduce(
        (sum, item) => sum + Number(item.unread),
        0
      );

        localStorage.setItem("chatUnreadCount", total);

      setChatUnread(total);

      

      
    }
  } catch (err) {
    console.error("Unread fetch error", err);
  }
};

useEffect(() => {
  if (!token) return;

  fetchUnreadCounts(); // initial load

  const handleNewMessage = () => {
    const current = Number(localStorage.getItem("chatUnreadCount")) || 0;
    const updated = current + 1;

    localStorage.setItem("chatUnreadCount", updated);
    window.dispatchEvent(new Event("chatUnreadUpdated"));
  };

  socket.on("new_message_notification", handleNewMessage);

  return () => {
    socket.off("new_message_notification", handleNewMessage);
  };

}, [token]);

useEffect(() => {
  const update = () => {
    const value = Number(localStorage.getItem("chatUnreadCount")) || 0;
    setChatUnread(value);
  };

  window.addEventListener("chatUnreadUpdated", update);

  return () => {
    window.removeEventListener("chatUnreadUpdated", update);
  };
}, []);

  return (
    <>
      {/* ================= HEADER ================= */}
      <header className="sticky top-0 z-50 w-full bg-black shadow-md">
        <div className="flex items-center justify-between h-20 px-6">

          {/* LEFT */}
          <div className="flex items-center gap-5">
            {isAuthenticated && (
              <Button
                type="text"
                icon={<MenuOutlined className='hover:text-white'/>}
                onClick={() => setDrawerOpen(true)}
                className="w-12 h-12 text-xl text-white hover:text-white"
              />
            )}

            <div
              className="flex items-center gap-1 cursor-pointer"
              onClick={() => navigate('/')}
            >
              <img
                src={logo}
                alt="Logo"
                className="object-contain w-12 h-12"
              />
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex items-center gap-4 mr-8">
            {!isAuthenticated  ? (
              <Link
                to="/user/sign_in"
                className="px-4 py-2 font-sans font-semibold text-black bg-white border-2 rounded-md hover:bg-slate-50"
              >
                Login
              </Link>
            ) : (
              <Dropdown menu={{ items: userMenuItems }} trigger={['click']}>
                <div className="flex items-center gap-3 cursor-pointer">
                  <Avatar
                    size={42}
                    src={avatarUrl || undefined}
                    className="border border-gray-200 shadow-sm"
                  >
                    {!avatarUrl &&
                      (fullName ? getInitials(fullName) : <UserOutlined />)}
                  </Avatar>

                  <div className="flex flex-col">
                    <span className="text-sm font-semibold text-white">
                      {fullName}
                    </span>
                  </div>

                  <DownOutlined className='text-white'/>
                </div>
              </Dropdown>
            )}
          </div>
        </div>
      </header>

      {/* ================= DRAWER ================= */}
      <Drawer
        placement="left"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={400}
        closable={false}
      >
        {/* Logo */}
        <div className="flex items-center pb-4 mb-4 border-b cursor-pointer"
        onClick={() => navigate('/')}>
          <img src={logo} alt="Logo" className="w-12 h-12" />
          <div className="ml-2 text-xl font-bold">PRACTICAL INFOSEC</div>
        </div>

        {/* Student Status */}
        {role === 'STUDENT' && studentStatus && (
          <div className="px-2 pb-4">
            <div className="flex items-center justify-between px-4 py-2 text-green-700 bg-green-100 border border-green-200 rounded-lg">
              <span className="font-semibold">Student Status</span>
              <span className="flex items-center gap-2 font-bold">
                <span className="w-2.5 h-2.5 bg-green-500 rounded-full"></span>
                {studentStatus}
              </span>
            </div>
          </div>
        )}

        {/* Navigation */}
       {navItems.map((item) => {

  const ROLE_BASE_PATHS = {
    ADMIN: "/academy/admin",
    STUDENT: "/academy/mentee-dashboard",
    INSTRUCTOR: "/academy/mentor-dashboard",
    OPERATIONS: "/academy/operations",
  };

  let path;

  if (item === "Home") {
    path = ROLE_HOME_ROUTES[role] || "/";
  } else {
    const basePath = ROLE_BASE_PATHS[role] || "/academy";
    path = `${basePath}/${slugify(item)}`;
  }

  const isActive = location.pathname.startsWith(path);

 return (
  <button
    key={item}
    onClick={() => handleNavClick(item)}
    className={`group flex items-center justify-between w-full px-4 py-3 mb-2 font-semibold text-left rounded-md
      transform transition-all duration-200 ease-in-out
      ${
        isActive
          ? "bg-black text-[#ffd104] scale-[1.03]"
          : "text-gray-900 hover:bg-black hover:text-[#ffffff] hover:scale-[1.06]"
      }`}
  >

    {/* LEFT */}
    <div className="flex items-center gap-3">

      {/* ICON */}
      <span
        className={`text-xl transition-all duration-200
          ${
            isActive
              ? "text-[#ffd104]"
              : "text-gray-900 group-hover:text-[#ffffff] group-hover:scale-110"
          }`}
      >
        {NAV_ICONS[item]}
      </span>

      {/* TEXT */}
      <span
        className={`transition-all duration-200
          group-hover:font-bold group-hover:tracking-wide`}
      >
        {item}
      </span>
    </div>

    {/* RIGHT (BADGE) */}
    {item === "Chats" && chatUnread > 0 && (
      <span className="px-2 py-0.5 text-xs font-bold text-white bg-black rounded-full group-hover:bg-white group-hover:text-red-500 transition-all duration-200">
        {chatUnread}
      </span>
    )}

  </button>
);
})}
      </Drawer>
    </>
  );
}
